import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";

export async function getSession(currentUser: CognitoUser): Promise<CognitoUserSession> {
	return new Promise((resolve, reject) => {
		currentUser.getSession((error: any, session: CognitoUserSession) => {
			if (error) {
				reject(error);
			}
			resolve(session);
		});
	});
}
